export default __webpack_public_path__ + "static/media/Icon2.dc9fa64c.svg";